/**
 * Test IDs for QA automation.
 */
export const testIds = {
  tractorFormAssetCode: "tractor-form-asset-code",
  tractorFormVinNumber: "tractor-form-vin-number",
  tractorFormLicenseNumber: "tractor-form-license-number",
  tractorFormMake: "tractor-form-make",
  tractorFormModel: "tractor-form-model",
  tractorFormYear: "tractor-form-year",
  tractorFormExternalId: "tractor-form-external-id",
  tractorFormStatus: "tractor-form-status",
  tractorFormOpenDocument: "tractor-form-open-document",
  tractorFormRemoveDocument: "tractor-form-remove-document",
  tractorFormSave: "tractor-form-save",
} as const;
